import { cva as i } from "class-variance-authority";
var a = i("lib:shrink-0 lib:animate-spin", {
  variants: { size: {
    sm: "lib:size-4",
    md: "lib:size-6",
    lg: "lib:size-10"
  } },
  defaultVariants: { size: "md" }
});
export {
  a as spinnerVariants
};
